import { useEffect } from 'react';
import type { EligibleExistingContractedCapacitiesResponse } from 'src/apis/reshuffle-service/types';
import type { AllocationDetailsRequest } from 'src/apis/reshuffle-service/use-allocation';
import { useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

type ExecuteProps = { url: string };

type HookConfig = {
  allocationDetails: AllocationDetailsRequest;
};

export function useEligibleExistingContractedCapacities({
  allocationDetails,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<EligibleExistingContractedCapacitiesResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!allocationDetails.response) return;

    if (
      !allocationDetails.response.data._links
        .getEligibleExistingContractedCapacities
    ) {
      throw new Forbidden();
    }

    request.execute({
      url: allocationDetails.response.data._links
        .getEligibleExistingContractedCapacities.href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [allocationDetails.response]);

  return request;
}

export type EligibleExistingContractedCapacitiesRequest = ReturnType<
  typeof useEligibleExistingContractedCapacities
>;
